<template>
  <div>
    <NavBar
      :title="title"
      :fixed="true"
      :placeholder="true"
      safe-area-inset-top
      :left-arrow="leftArrow"
      :left-text="leftText"
      @click-left="onClickLeft"
      :class="[this.websocket == true ? '' : 'titleClass']"
    >
      <template #right>
        <img
          v-if="rightIcons_pad"
          src="@/assets/img/Ticket.svg"
          style="width: 30px; margin-top: -5px; margin-right: 18px"
          alt=""
          @click="openAdd"
        />
        <div v-if="rightIcons">
          <van-icon
            style="margin-right: 15px"
            name="replay"
            size="18"
            @click="onRefresh"
          />
          <!-- <van-icon name="user-o" size="18" @click="user" /> -->
        </div>
        <div v-if="rightAdd">
          <van-icon
              name="add-o"
              style="margin-right: 15px"
              size="18"
              @click="onClickRightAdd"/>
        </div>
      </template>
      <template #left v-if="leftIcons">
        <img
          src="@/assets/img/Ticket.svg"
          style="width: 30px"
          alt=""
          @click="openAdd"
        />
      </template>
    </NavBar>
  </div>
</template>

<script>
  import {NavBar, Toast} from "vant";
  import Stand from "@/pages/stand/stand";

  export default {
  name: "Header",
  props: {
    msg: String,
    leftArrow: {
      default: false,
    },
    leftText: {
      default: "",
    },
    rightIcons: {
      default: true,
    },
    rightIcons_pad: {
      default: false,
    },
    leftIcons: {
      default: false,
    },
    rightAdd: {
      default: false,
    },
    pageTitle:{
      default: "",
    }
  },
  data() {
    return {
      title: "トップページ",
      firstTitle:"",
      titleInterval:null,
      websocket:true,
    };
  },
  components: {
    Stand,
    NavBar
  },
  mounted() {
    if(this.pageTitle!=""){
      this.firstTitle = this.pageTitle;
    }else{
      this.firstTitle = this.$route.meta.title;
    }

    // 定时器
    if(this.titleInterval){
      clearInterval(this.titleInterval);
    }
    this.setTitle();
    this.titleInterval = setInterval(() => {
      this.setTitle();
    }, 5000);
  },
  beforeUnmount(){
    if(this.titleInterval){
      clearInterval(this.titleInterval);
    }
  },
  watch: {
    $route(to, from) {
      // this.title = to.meta.title;
    },
    pageTitle(value){
      this.firstTitle = value;
      this.setTitle();
    },
  },
  methods: {
    setTitle(){
      if("online" ===localStorage.getItem('tsunagaru-websocket')){
        this.websocket = true;
        this.title = this.firstTitle
      }else{
        this.websocket = false;
        this.title = this.firstTitle +"(通信異常)";
      }

    },
    onClickLeft() {
      this.$emit("leftClick");
    },
    onClickRightAdd() {
      this.$emit("rightAdd");
    },
    onRefresh() {
      // this.$emit("onRefreshClick");
      Toast.loading({
        message: "",
        forbidClick: true,
        duration: 1000,
      });

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    openAdd() {
      this.$emit("openAddClick");
    },
    user() {
      this.$router.push("/user");
    },
  },
};
</script>

<style scoped>
  /deep/.titleClass .van-nav-bar__title{
    color:red!important;
  }
</style>